export default __webpack_public_path__ + "static/media/infoIcon.7685d36f.svg";